import { css } from "@emotion/react";
import GBtn from "./GBtn";

type Props = Omit<React.ComponentProps<typeof GBtn>, "handleClick">;

export default function GBtnTextWave(props: Props) {
  const waveStyles = css`
    & span {
      display: inline-block;
      min-width: 0.3em;
      transition: 0.3s cubic-bezier(0.5, -1, 0.5, 2);
      opacity: 0;
      transform: translate(0, -20px);
    }

    &:before {
      content: attr(data-text);
      position: absolute;
      width: 100%;
      left: 0;
      transition: 0.4s cubic-bezier(0.5, -1, 0.5, 2);
      opacity: 1;
      transform: translate(0, 0px);
      text-align: center;
    }

    &:hover:before,
    &:focus:before {
      opacity: 0;
      transform: translate(0, 20px);
    }

    &:hover span,
    &:focus span {
      opacity: 1;
      transform: translate(0, 0);
    }

    &:hover span,
    &:focus span {
      transition-delay: calc(0.03s * var(--span-index));
    }
  `;

  const handleTextSplit = () => {
    return props.text?.split("").map((t, index) => (
      // @ts-ignore
      <span key={index} style={{ "--span-index": index + 1 }}>
        {t}
      </span>
    ));
  };

  return (
    <GBtn css={waveStyles} {...props} handleTextSplit={handleTextSplit}></GBtn>
  );
}

// We need to add the below in framer
/*

addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    fontColor: {
        title: "Font Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    background: {
        title: "Background",
        type: ControlType.Color,
        defaultValue: "#21242C",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 16,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
    radius: {
        title: "Radius",
        type: ControlType.Number,
        defaultValue: 8,
    },
    url: {
        title: "URL",
        type: ControlType.Link,
        defaultValue: "Home",
    },
    ripple: {
        title: "Ripple",
        type: ControlType.Boolean,
        description: "Adds a ripple effect on click if true",
        defaultValue: true,
    },
    preWaveText: {
        title: "Text 1",
        defaultValue: "Hover",
        type: ControlType.String,
        description: "Text that should be shown before hovering",
    },
})
*/
